<app-aumico-layout>
    <ng-container header>
        <aum-action-header
            class="no-space"
            [breadcrumbItems]="breadcrumbItems"
            [hasBackButton]="false"
            [pageHeader]="pageHeader"
        >
        </aum-action-header>
    </ng-container>
    <ng-container content>
        <div style="padding: 0">
            <div class="valuation-container">
                <div class="descriptive-title">
                    <span> {{ 'aumico_reports_company_valuation_report_title' | i18next }}</span>
                </div>
                <div class="valuation-report-content">
                    <div class="descriptive-text-box">
                        <mat-icon svgIcon="aumico-pattern-icon-lock"></mat-icon>
                        <div class="descriptive-text">
                            {{ 'aumico_reports_company_valuation_report_descriptive_text_1' | i18next }}
                        </div>
                    </div>
                    <div class="descriptive-text-box">
                        <div class="descriptive-text-box">
                            <mat-icon svgIcon="aumico-pattern-icon-lock"></mat-icon>
                            <div class="descriptive-text">
                                {{ 'aumico_reports_company_valuation_report_descriptive_text_2' | i18next }}
                            </div>
                        </div>
                    </div>
                    <div class="descriptive-text-box">
                        <div class="descriptive-text-box">
                            <mat-icon svgIcon="aumico-pattern-icon-lock"></mat-icon>
                            <div class="descriptive-text">
                                {{ 'aumico_reports_company_valuation_report_descriptive_text_3' | i18next }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="valuation-buttons">
                    <div>
                        <button
                            aum-icon-button
                            icon="download"
                            color="basic"
                            (click)="onDownloadExampleValuationFileClick()"
                        >
                            {{ 'aumico_reports_company_valuation_report_download_button_text' | i18next }}
                        </button>
                    </div>
                    <div>
                        <button aum-button color="blue">
                            {{ 'aumico_reports_company_valuation_report_order_button_text' | i18next }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</app-aumico-layout>
